import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import { LanguageProvider } from "@/lib/i18n";
import { SeoHead } from "@/components/site/SeoHead";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TrustBar } from "@/components/site/TrustBar";
import { CottageGrid } from "@/components/site/CottageGrid";
import { Amenities } from "@/components/site/Amenities";
import { Pricing } from "@/components/site/Pricing";
import { Gallery } from "@/components/site/Gallery";
import { Testimonials } from "@/components/site/Testimonials";
import { Attractions } from "@/components/site/Attractions";
import { Location } from "@/components/site/Location";
import { FAQ } from "@/components/site/FAQ";
import { ContactCTA } from "@/components/site/ContactCTA";
import { SiteFooter } from "@/components/site/SiteFooter";
import { LandingPage } from "@/pages/LandingPage";

const HomeShell = () => (
  <div className="min-h-screen bg-background text-foreground">
    <SeoHead />
    <Navbar />
    <main>
      <Hero />
      <TrustBar />
      <CottageGrid />
      <Amenities />
      <Pricing />
      <Gallery />
      <Testimonials />
      <Attractions />
      <Location />
      <FAQ />
      <ContactCTA />
    </main>
    <SiteFooter />
    <Toaster position="top-center" richColors closeButton />
  </div>
);

const LocaleRoot = ({ lang, children }) => (
  <LanguageProvider lang={lang}>{children ?? <HomeShell />}</LanguageProvider>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LocaleRoot lang="sk" />} />
          {/* Keyword landing pages, paths registered in src/lib/seoRoutes.json */}
          <Route
            path="/chata-pri-liptovskej-mare"
            element={
              <LocaleRoot lang="sk">
                <LandingPage id="mara" withGuide />
              </LocaleRoot>
            }
          />
          <Route
            path="/chata-izipovce"
            element={
              <LocaleRoot lang="sk">
                <LandingPage id="izipovce" />
              </LocaleRoot>
            }
          />
          <Route path="/en" element={<LocaleRoot lang="en" />} />
          <Route
            path="/en/liptovska-mara-cottage"
            element={
              <LocaleRoot lang="en">
                <LandingPage id="mara" withGuide />
              </LocaleRoot>
            }
          />
          <Route
            path="/en/chata-izipovce"
            element={
              <LocaleRoot lang="en">
                <LandingPage id="izipovce" />
              </LocaleRoot>
            }
          />
          <Route path="/en/*" element={<LocaleRoot lang="en" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
